import React from 'react';

import { SVGComponentProps } from './svg.types';

const StarRatingSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect y="0" width="14" height="2" fill={fill} />
        <rect y="4" width="14" height="2" fill={fill} />
        <svg y="7">
          <path
            d="M4.62664 2.42846L4.56656 2.30174L3.68965 0.451922C3.67261 0.416045 3.64574 0.385738 3.61216 0.364517C3.57859 0.343295 3.53968 0.332031 3.49996 0.332031C3.46025 0.332031 3.42134 0.343296 3.38777 0.364517C3.35422 0.385721 3.32737 0.415996 3.31032 0.451835C3.31031 0.451864 3.31029 0.451893 3.31028 0.451922L2.4334 2.30317L2.37335 2.42995L2.23384 2.44475L0.438341 2.63525L0.436765 2.63542L0.436765 2.63542C0.395459 2.63953 0.356308 2.65583 0.324279 2.68224C0.29225 2.70864 0.268788 2.74397 0.256869 2.78373C0.24495 2.82349 0.245112 2.8659 0.257334 2.90557C0.269556 2.94524 0.293288 2.98038 0.325518 3.00654L0.32675 3.00754L0.326747 3.00755L1.75875 4.18505L1.87764 4.28281L1.84387 4.43299L1.39896 6.4116C1.39895 6.41165 1.39894 6.41171 1.39892 6.41177C1.39001 6.45189 1.39306 6.49375 1.40771 6.53216C1.42237 6.57062 1.44802 6.60393 1.48146 6.62793C1.51491 6.65194 1.55466 6.66558 1.5958 6.66718C1.63687 6.66877 1.6775 6.65827 1.71266 6.63699L4.62664 2.42846ZM4.62664 2.42846L4.7661 2.44325L6.5621 2.63375L6.5621 2.63376L6.56432 2.63398C6.60577 2.638 6.64508 2.65428 6.67723 2.68075C6.70938 2.70721 6.73292 2.74266 6.74484 2.78256C6.75675 2.82246 6.7565 2.86501 6.74412 2.90477C6.73175 2.94453 6.7078 2.9797 6.67534 3.00579L6.67533 3.00578L6.67318 3.00755L5.24118 4.18505L5.12242 4.2827L5.156 4.43275L5.599 6.41225L5.59906 6.41253C5.60809 6.45264 5.60511 6.49453 5.5905 6.53296C5.57589 6.57139 5.55029 6.60468 5.5169 6.62867C5.4835 6.65266 5.44379 6.66629 5.4027 6.66786C5.36164 6.66944 5.32102 6.6589 5.2859 6.63757C5.28588 6.63756 5.28586 6.63754 5.28584 6.63753L3.6299 5.63007L3.50006 5.55107L3.37016 5.62999L1.71282 6.63689L4.62664 2.42846Z"
            fill="#55585E"
            stroke="#55585E"
            strokeWidth="0.5"
          />
        </svg>
      </svg>
    </span>
  );
};

export default StarRatingSVG;
